import p11 from "./image/project1/1.webp"
import p12 from "./image/project1/2.jpg"
import p13 from "./image/project1/3.jpg"
import p14 from "./image/project1/4.jpg"
import p15 from "./image/project1/5.jpg"
import p16 from "./image/project1/6.jpg"
import p17 from "./image/project1/7.jpg"
import p18 from "./image/project1/8.jpg"

import p21 from "./image/project2/0.png"
import p22 from "./image/project2/1.jpg"
import p23 from "./image/project2/2.jpg"
import p24 from "./image/project2/3.jpg"
import p25 from "./image/project2/4.jpg"
import p26 from "./image/project2/5.jpg"

import p31 from "./image/Project3/0.png"
import p32 from "./image/Project3/1.png"
import p33 from "./image/Project3/2.png"
import p34 from "./image/Project3/3.png"
import p35 from "./image/Project3/4.png"
import p36 from "./image/Project3/5.png"
import p37 from "./image/Project3/6.png"
import p38 from "./image/Project3/7.png"
import p39 from "./image/Project3/8.png"
import p310 from "./image/Project3/9.png"
import p311 from "./image/Project3/10.png"
import p312 from "./image/Project3/11.png"

export const project1=[
{img:p11},
{img:p12},
{img:p13},
{img:p14},
{img:p15},
{img:p16},
{img:p17},
{img:p18},
]

export const project2=[
    {img:p21},
    {img:p22},
    {img:p23},
    {img:p24},
    {img:p25},
    {img:p26},
]


export const project3=[
    {img:p31},
    {img:p32},
    {img:p33},
    {img:p34},
    {img:p35},
    {img:p36},
    {img:p37},
    {img:p38},
    {img:p39},
    {img:p310},
    {img:p311},
    {img:p312},
]
